/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AlertingHookParams = {
    scope: AlertingHookParams.scope;
    type: AlertingHookParams.type;
};

export namespace AlertingHookParams {

    export enum scope {
        ALL_EVENTS = 'ALL_EVENTS',
        LINKED_EVENTS = 'LINKED_EVENTS',
    }

    export enum type {
        DEFAULT = 'DEFAULT',
        GOOGLE_CHAT = 'GOOGLE_CHAT',
    }


}
